import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobileVideoPlayer: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiVideoPlayer_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiVideoPlayerRole',
      bindings: [
        {
          title: 'mobui_MobuiVideoPlayer_dataBinding_title_label',
          prop: 'title',
          supportedFieldTypes: [FieldType.text, FieldType.email],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'mobui_MobuiVideoPlayer_dataBinding_src_label',
          prop: 'src',
          supportedFieldTypes: [FieldType.video, FieldType.url],
          defaultFieldType: FieldType.video,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
